import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrencyPipe, Location } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { datetimeFormat } from 'app/constants/date-time-format';
import { CalculationService, DataService, DateService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { find } from 'lodash';

@Component({
  selector: 'app-authorization-parts-ordering',
  templateUrl: './authorization-parts-ordering.component.html',
  styleUrls: ['./authorization-parts-ordering.component.scss'],
  providers: [DialogService],
})
export class AuthorizationPartsOrderingComponent implements OnInit {
  @Input() estimate: any = {};
  @Input() isArchived: boolean = false;
  @Input() settings: any = {};
  @Input() customFleetSettings: any = {};
  @Input() vehicle: any = {};
  @Input() setPartsTechQoutes: any;
  @Input() setManualQoutes: any;
  @Input() setNexpartQoutes: any;
  @Input() partsTechSessionId: string = '';
  @Input() isOrderPlaced: boolean = false;
  @Input() isPartsTechEnabled: boolean = false;
  @Input() isNexpartEnabled: boolean = false;
  @Input() isManualPartOrderingEnabled: boolean = false;
  @Input() tags: any[] = [];
  @Input() dialogOpenFrom: string = '';
  @Input('selectedTab')
  set selectedTab(selectedTab: any) {
    if (selectedTab === 3) {
      if (this.estimate && this.estimate._id && this.estimate.partsTechSessionId) {
        this.isSyncedWithPartsTech();
      }

      this.setSelectedService(this.estimate.services);
    }
  }
  @Input('partsTechLastSynced')
  set partsTechLastSynced(lastSynced: any) {
    if (lastSynced) {
      this.lastSynced = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(lastSynced).getTime()), datetimeFormat.mmmdyyhhmmaa);
    }
  }
  @Input('partsTechOrderPlacedAt')
  set partsTechOrderPlacedAt(placeOrderAt: any) {
    if (placeOrderAt) {
      this.placeOrderAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(placeOrderAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
    }
  }
  @Input('estimateService')
  set estimateService(estimateService: any) {
    if (estimateService) {
      this.services = [...estimateService];
      this.setSelectedService(estimateService);
    }
  }
  @Input('partsTechQoutes')
  set partsTechQoutes(data: any) {
    let orders = [];
    this._partsTechQoutes = [];

    if (this.isAlreadySettinged) {
      this.isAlreadySettinged = false;
      return;
    }

    if (data && data.length) {
      data.forEach((qoute: any) => {
        this._partsTechQoutes.push(qoute);
        orders = [...orders, qoute];
      });

      this.hasOrders = !!orders.length;
      this.orders = this.setOrderDetails(data, false);
      this.defaultOrders = this.helperService.deepCopy(this.orders);
    }
  }
  @Input('nexpartQoutes')
  set nexpartQoutes(data: any) {
    let orders = [];

    if (data && data.length >= 0) {
      data.forEach((qoute: any) => {
        this._nexpartQoutes.push(qoute);
        orders = [...orders, qoute];
      });
      this._orders.nexpart = this.setNexpartDetails(data, false);
    }
  }
  @Input('manualQoutes')
  set manualQoutes(data: any) {
    let orders = [];

    if (data && data.length >= 0) {
      data.forEach((qoute: any) => {
        this._manualQoutes.push(qoute);
        orders = [...orders, qoute];
      });
      this._orders.manualOrder = this.setManualOrderDetails(data);
    }
  }
  @Input() isFinalizedRo: boolean = false;

  @Output() syncPartsTechParts = new EventEmitter<any>();
  @Output() updateOrderServices = new EventEmitter<any>();
  @Output() getEstimatesById = new EventEmitter<any>();
  @Output() appUpdateManualItemOrder = new EventEmitter();
  _partsTechQoutes: any[] = [];
  _nexpartQoutes: any[] = [];
  _manualQoutes: any[] = [];
  _orders = {
    nexpart: [],
    manualOrder: [],
  };
  hasOrders: boolean = false;
  orders: any[] = [];
  parts: any[] = [];
  _parts = { nexpart: [], manualOrder: [] };
  suppliers: any = {};
  _suppliers = { nexpart: {} as any, manualOrder: {} as any };
  totalSuppliers: any[] = [];
  _totalSuppliers = { nexpart: [] as any, manualOrder: [] as any };
  orderTotal: any = {};
  _orderTotal = { nexpart: {} as any, manualOrder: {} as any };
  usd: string = currency.USD;
  lastSynced: any = '';
  placeOrderAt: any = '';
  orderPlacedAt: any = '';
  isOpeningCart: boolean = false;
  isNexpartLoading: boolean = false;
  isManualOrderLoading: boolean = false;
  isSyncing: boolean = false;
  isSyncingChecking: boolean = false;
  isOrderPlacing: boolean = false;
  services: any[] = [];
  partsService: any = {};
  defaultOrders: any[] = [];
  partsTechRedirectUrl: string = '';
  isAlreadySettinged: boolean = false;
  supplierTotal: any = {};
  _supplierTotal = { nexpart: {}, manualOrder: {} };
  isPlacingOrder = {
    nexpart: false,
    partstech: false,
    manualOrder: false,
  };
  isModifyingOrder = {
    nexpart: false,
    partstech: false,
    manualOrder: false,
  };

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dateService: DateService,
    private dialogService: DialogService,
    private currencyPipe: CurrencyPipe,
    private calculationService: CalculationService,
    private location: Location,
    public dataService: DataService
  ) {}

  ngOnInit = () => {};

  openOrderPartsTechLink = () => {
    window.open(this.partsTechRedirectUrl, this.estimate.partsTechSessionId);
  };

  modifyNexpartQoute = (accountId: string, page?: string) => {
    if (this.isFinalizedRo) return;
    this.location.replaceState(`/estimate/${this.estimate._id}?reload=true`);
    if (this.isOpeningCart) return;

    this.isOpeningCart = true;
    this.isNexpartLoading = true;
    this.isPlacingOrder.nexpart = page === 'review';
    this.isModifyingOrder.nexpart = page !== 'review';
    this.httpService
      .createNextpartQoute({
        orderId: this.estimate._id,
        // credentialId: accountId,
        page,
        isTriggerFromDialog: true,
        openFrom: this.dialogOpenFrom === 'kanban' ? 'workboard' : 'order',
      })
      .then(
        (res) => {
          window.open(res.redirectUrl, '_self');
          this.isOpeningCart = false;
        },
        (err) => {
          this.isOpeningCart = false;
          this.isNexpartLoading = false;
          this.isPlacingOrder.nexpart = false;
          this.isModifyingOrder.nexpart = false;
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isNexpartLoading = false;
      });
  };

  getPartService = (orderItemId: string, itemSourceId: string) => {
    if (!!this.partsService[orderItemId]) {
      return this.partsService[orderItemId];
    }

    return null;
  };

  // We are gettings lineCardId from PartsTech but the local ALP mapping key for it is lineCartId
  setSelectedService = (services: any[]) => {
    this.partsService = {};
    services.forEach(({ _id, title, items, titleFR }) => {
      items.forEach(({ itemSource, itemSourceId, orderItemId }) => {
        if (itemSource === 'PartsTech') {
          if (orderItemId) {
            this.partsService[orderItemId] = {
              _id: itemSourceId,
              title: title || titleFR,
            };
          }
        }

        if (itemSource === 'Nexpart' && orderItemId) {
          this.partsService[orderItemId] = {
            _id: itemSourceId,
            title: title || titleFR,
          };
        }
      });
    });
  };

  setNexpartDetails = (qoutes: any[], triggerSync: boolean = true, setFirstCartAsMutable: boolean = false) => {
    this._parts.nexpart = [];
    this._suppliers.nexpart = {};
    this._totalSuppliers.nexpart = [];
    this._orderTotal.nexpart = {
      cost: 0,
      quantity: 0,
      orderTotal: 0,
      shippingPrice: 0,
    };

    qoutes.forEach(({ id, orders = [], isOrderPlaced, sessionId }, index) => {
      const suppliers = [];

      qoutes[index].orders = orders.map((order: any) => {
        const {
          Name,
          Total,
          ItemCount,
          ListTotal,
          SellerId,
          BranchId,
          OrderHeader,
          Parts: { Part = [] },
        } = order;
        const orderSupplier = {
          orderNo: OrderHeader && OrderHeader.OrderNumber,
          name: Name,
          quantity: Number(ItemCount),
          cost: Number(Total),
          shippingPrice: 0,
          orderTotal: Number(Total),
        };

        order.totalPrice = 0;
        order.coreCharge = 0;
        order.supplier = {
          id: SellerId,
          name: Name,
          orderNo: OrderHeader && OrderHeader.OrderNumber,
        };

        order.parts = Part.map(({ PartNumber, LineCode, MfgCode, AvailableQty, Core, List, Mdse, OrderQty, SellerPartDesc, CatalogPartDesc }) => {
          const part: any = {
            quantity: Number(OrderQty),
            supplier: { name: orderSupplier.name },
            partName: SellerPartDesc,
            partNumber: PartNumber,
            description: CatalogPartDesc,
            imageUrl: '',
            availability: !!Number(AvailableQty),
            orderItemId: `${sessionId}-${SellerId}-${BranchId}-${LineCode}-${PartNumber}`,
            partId: PartNumber,
            lineCardId: LineCode,
            itemSource: 'Nexpart',
            price: {
              list: Number(List),
              price: Number(List),
              cost: Number(Mdse),
              core: Number(Core),
            },
          };

          // Calculating total amount
          part.amount = part.quantity * part.price.cost;

          // Setting devliery status (Part unsubmitted parts we use both availability and delivery method)
          part.status = part.availability ? 'Available' : 'Unavailable';

          return part;
        });

        orderSupplier.orderTotal = orderSupplier.cost + orderSupplier.shippingPrice;
        suppliers.push(orderSupplier);

        return order;
      });

      this._suppliers.nexpart[id] = suppliers;
      this._totalSuppliers.nexpart = [...this._totalSuppliers.nexpart, ...suppliers];
    });

    const mergedSupplier = {};
    this._totalSuppliers.nexpart.forEach((supplier) => {
      if (!mergedSupplier[supplier.name]) {
        mergedSupplier[supplier.name] = {
          name: supplier.name,
          quantity: 0,
          cost: 0,
          shippingPrice: 0,
          orderTotal: 0,
        };
      }

      mergedSupplier[supplier.name].quantity += supplier.quantity;
      mergedSupplier[supplier.name].cost += supplier.cost;
      mergedSupplier[supplier.name].shippingPrice += supplier.shippingPrice;
      mergedSupplier[supplier.name].orderTotal += supplier.orderTotal;
    });

    this._totalSuppliers.nexpart = Object.values(mergedSupplier);

    Object.keys(this._suppliers.nexpart).forEach((key) => {
      this._supplierTotal.nexpart[key] = {
        cost: 0,
        quantity: 0,
        orderTotal: 0,
        shippingPrice: 0,
      };

      this._suppliers.nexpart[key].forEach(({ quantity, cost, shippingPrice, orderTotal }) => {
        this._supplierTotal.nexpart[key].quantity += quantity;
        this._supplierTotal.nexpart[key].cost += cost;
        this._supplierTotal.nexpart[key].shippingPrice += shippingPrice;
        this._supplierTotal.nexpart[key].orderTotal += orderTotal;

        this._orderTotal.nexpart.quantity += quantity;
        this._orderTotal.nexpart.cost += cost;
        this._orderTotal.nexpart.shippingPrice += shippingPrice;
        this._orderTotal.nexpart.orderTotal += orderTotal;
      });
    });

    return qoutes;
  };

  setManualOrderDetails(qoutes: any[]) {
    this._parts.manualOrder = [];
    this._suppliers.manualOrder = {};
    this._totalSuppliers.manualOrder = [];
    this._orderTotal.manualOrder = {
      cost: 0,
      quantity: 0,
      orderTotal: 0,
      shippingPrice: 0,
    };

    qoutes.forEach(({ id, orders = [], isOrderPlaced }, index) => {
      const suppliers = [];

      if (qoutes[index] && qoutes[index].qoute && qoutes[index].qoute.orders)
        qoutes[index].qoute.orders = qoutes[index].qoute.orders.map((order: any) => {
          const { title, items } = order;
          const orderSupplier = {
            quantity: 0,
            cost: 0,
            shippingPrice: 0,
            orderTotal: 0,
          };

          order.totalPrice = 0;
          order.coreCharge = 0;
          order.supplier = {};

          order.items = items.map((item: any) => {
            // Calculating total amount
            item.amount = item.quantity * item.price;
            // Setting devliery status (Part unsubmitted parts we use both availability and delivery method)
            item.status = item.availability ? 'Available' : 'Unavailable';

            return item;
          });

          orderSupplier.orderTotal = orderSupplier.cost + orderSupplier.shippingPrice;
          suppliers.push(orderSupplier);

          return order;
        });

      this._suppliers.manualOrder[id] = suppliers;
      this._totalSuppliers.manualOrder = [...this._totalSuppliers.manualOrder, ...suppliers];
    });

    const mergedSupplier = {};
    this._totalSuppliers.manualOrder.forEach((supplier) => {
      if (!mergedSupplier[supplier.name]) {
        mergedSupplier[supplier.name] = {
          name: supplier.name,
          quantity: 0,
          cost: 0,
          shippingPrice: 0,
          orderTotal: 0,
        };
      }

      mergedSupplier[supplier.name].quantity += supplier.quantity;
      mergedSupplier[supplier.name].cost += supplier.cost;
      mergedSupplier[supplier.name].shippingPrice += supplier.shippingPrice;
      mergedSupplier[supplier.name].orderTotal += supplier.orderTotal;
    });

    this._totalSuppliers.manualOrder = Object.values(mergedSupplier);

    Object.keys(this._suppliers.manualOrder).forEach((key) => {
      this._supplierTotal.manualOrder[key] = {
        cost: 0,
        quantity: 0,
        orderTotal: 0,
        shippingPrice: 0,
      };

      this._suppliers.manualOrder[key].forEach(({ quantity, cost, shippingPrice, orderTotal }) => {
        this._supplierTotal.manualOrder[key].quantity += quantity;
        this._supplierTotal.manualOrder[key].cost += cost;
        this._supplierTotal.manualOrder[key].shippingPrice += shippingPrice;
        this._supplierTotal.manualOrder[key].orderTotal += orderTotal;

        this._orderTotal.manualOrder.quantity += quantity;
        this._orderTotal.manualOrder.cost += cost;
        this._orderTotal.manualOrder.shippingPrice += shippingPrice;
        this._orderTotal.manualOrder.orderTotal += orderTotal;
      });
    });

    return qoutes;
  }

  setOrderDetails = (qoutes: any[], triggerSync: boolean = true, setFirstCartAsMutable: boolean = false) => {
    this.parts = [];
    this.suppliers = {};
    this.totalSuppliers = [];
    this.orderTotal = {};
    this.orderTotal = {
      cost: 0,
      quantity: 0,
      orderTotal: 0,
      shippingPrice: 0,
    };
    const oldPart = {};
    const partsTechParts: any = {};

    // Creating map of old price and cost
    this.orders.forEach(({ orders = {} }) => {
      const { parts = [] } = orders;

      parts.forEach(({ price, partId }) => {
        oldPart[partId] = {
          price: price.list,
          cost: price.cost,
        };
      });
    });

    qoutes.forEach(({ id, orders = [], isOrderPlaced }, index) => {
      const suppliers = [];

      orders.forEach((order: any) => {
        const { supplier = {}, parts = [], delivery = {} } = order;
        const orderSupplier = {
          name: supplier.name,
          quantity: 0,
          cost: 0,
          shippingPrice: delivery.price || 0,
          orderTotal: 0,
        };

        parts.forEach((part: any) => {
          const oPart = oldPart[part.partId];

          // Doing sum of quantity and cost of part for current supplier
          orderSupplier.quantity += part.quantity;
          orderSupplier.cost += part.quantity * (part.price.cost +(part?.price?.core || 0));
          part.itemSource = 'PartsTech';
          // Adding supplier to the part to add them in RO
          part.supplier = { name: supplier.name };

          // Show tooltip if cost has been updated
          if (oPart && part.price.cost !== oPart.cost) {
            part.isCostUpdated = true;
            part.costUpdateMessage = `This Part's cost was previously ${this.currencyPipe.transform(oPart.cost, this.usd)}`;
          }

          // Show tooltip if price has been updated
          if (oPart && part.price.list !== oPart.price) {
            part.isPriceUpdated = true;
            part.priceUpdateMessage = `This Part's price was previously ${this.currencyPipe.transform(oPart.price, this.usd)}`;
          }

          // Calculating total amount
          part.amount = part.quantity * part.price.cost;

          // Setting devliery status (Part unsubmitted parts we use both availability and delivery method)
          if (part.deliveryStatus) {
            part.status = part.deliveryStatus;
          } else {
            part.status = part.availability && delivery.name ? 'Available' : 'Unavailable';
          }

          // Adding all the parts into an array.
          this.parts.push({
            name: part.partName,
            supplier: supplier.name,
            quantity: part.quantity,
            lPrice: part.price.list,
            cost: part.price.cost,
            price: part.price.price,
          });
          // Creating item map for autoleap service line item
          if (index === 0 && setFirstCartAsMutable) {
            partsTechParts[part.orderItemId] = this.mapPartToAlpPart(part, order, true);
          } else {
            partsTechParts[part.orderItemId] = this.mapPartToAlpPart(part, order, isOrderPlaced);
          }
        });

        orderSupplier.orderTotal = orderSupplier.cost + orderSupplier.shippingPrice;
        suppliers.push(orderSupplier);
      });

      this.suppliers[id] = suppliers || [];
      this.totalSuppliers = [...this.totalSuppliers, ...suppliers];
    });

    const mergedSupplier = {};
    this.totalSuppliers.forEach((supplier) => {
      if (!mergedSupplier[supplier.name]) {
        mergedSupplier[supplier.name] = {
          name: supplier.name,
          quantity: 0,
          cost: 0,
          shippingPrice: 0,
          orderTotal: 0,
        };
      }

      mergedSupplier[supplier.name].quantity += supplier.quantity;
      mergedSupplier[supplier.name].cost += supplier.cost;
      mergedSupplier[supplier.name].shippingPrice += supplier.shippingPrice;
      mergedSupplier[supplier.name].orderTotal += supplier.orderTotal;
    });

    this.totalSuppliers = Object.values(mergedSupplier);
    this.supplierTotal = {
      quantity: 0,
      cost: 0,
      shippingPrice: 0,
      orderTotal: 0,
    };

    Object.keys(this.suppliers).forEach((key) => {
      this.supplierTotal[key] = {
        cost: 0,
        quantity: 0,
        orderTotal: 0,
        shippingPrice: 0,
      };

      this.suppliers[key].forEach(({ quantity, cost, shippingPrice, orderTotal }) => {
        this.supplierTotal[key].quantity += quantity;
        this.supplierTotal[key].cost += cost;
        this.supplierTotal[key].shippingPrice += shippingPrice;
        this.supplierTotal[key].orderTotal += orderTotal;

        this.orderTotal.quantity += quantity;
        this.orderTotal.cost += cost;
        this.orderTotal.shippingPrice += shippingPrice;
        this.orderTotal.orderTotal += orderTotal;
      });
    });

    // Trigger syncing in services line items
    if (triggerSync) {
      // partsTechParts.updateDelivertStatusOnly = updateDelivertStatusOnly;
      this.syncPartsTechParts.emit(partsTechParts);
    }

    return qoutes;
  };

  placeOrder = (forcePlaceOrder: boolean = false, isOverwrite: boolean = false) => {
    if (this.isOrderPlacing || this.isFinalizedRo) {
      return;
    }
    this.isOrderPlacing = true;
    this.httpService
      .placePartsTechOrder(this.estimate._id, forcePlaceOrder, isOverwrite)
      .then(
        (order: any) => {
          if (!order.isSynced) {
            this.openReviewChangedDialog();
            this.isAlreadySettinged = true;
            this.estimate.isSyncedWithPartsTech = true;
            this.orders = this.setOrderDetails(this.setPartsTechQoutes(order), isOverwrite, true);
          } else {
            this.isOrderPlaced = true;
            this.partsTechRedirectUrl = order.partsTechRedirectUrl;
            this.placeOrderAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(order.partsTechOrderPlacedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
            this.orders = this.setOrderDetails(this.setPartsTechQoutes(order), false, true);
            this.getEstimatesById.emit();
            this.syncManualOrder(order);
          }
        },
        (err) => {
          if (err.code === 'OrderAvailabilityError') {
            this.helperService.showToaster('error', 'To place your order, remove any unavailable Part');
          } else {
            this.helperService.showToaster('error', err.message);
          }
        }
      )
      .finally(() => {
        this.isOrderPlacing = false;
      });
  };

  isSyncedWithPartsTech = () => {
    if (this.isSyncingChecking) {
      return;
    }

    this.isSyncingChecking = true;
    this.httpService
      .isSyncedWithPartsTech(this.estimate._id)
      .then(
        (res) => {
          if (res.orders && res.orders.length) {
            this.orders = this.setOrderDetails(this.setPartsTechQoutes(res.roOrder), false);
          } else {
            this.estimate.isSyncedWithPartsTech = res.isSyncedWithPartsTech;
          }
        },
        (err) => {}
      )
      .finally(() => {
        this.isSyncingChecking = false;
      });
  };

  openReviewChangedDialog = () => {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Review changes in cart`,
        message: `There have been cost changes on Part(s) within your cart. Please review your updated cart before submitting this Parts Order.`,
        button: {
          success: { title: 'Submit cart' },
          cancel: { title: 'Review changes' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.placeOrder();
      }

      onClose.unsubscribe();
    });
  };

  mapPartToAlpPart = (part: any, order: any, isOrderPlaced: boolean = false) => {
    // if (!this.settings) {
    //   this.settings = {};
    // }

    const item: any = {
      isOrderPlaced,
      code: part.partNumber,
      type: 'part',
      count: part.quantity,
      defaultCount: part.quantity,
      cost: part.price.cost,
      actualCost: part.price.cost,
      coreCost: part.price.core,
      price: part.price.list,
      status: true,
      itemId: 'no-id',
      title: part.partName || '',
      poNumber: order.poNumber || '',
      imgUrl: part.imageUrl,
      description: part.description || `${part.partNumber}`,
      partOrderId: order.id,
      orderItemId: part.orderItemId,
      lineCartId: part.lineCardId,
      itemSource: part.itemSource || 'PartsTech',
      subTotal: part.price.list * part.quantity,
      itemSourceId: part.partId,
      isCostUpdated: part.isCostUpdated,
      costUpdateMessage: part.costUpdateMessage,
      priceUpdateMessage: part.priceUpdateMessage,
      isPriceUpdated: part.isPriceUpdated,
      subheading: '',
      tags: [],
      unitOfMeasuring: '',
      supplier: part.supplier,
      discount: { value: 0, type: 'percentage', name: 'Percent' },
    };

    if (part.taxonomy && new RegExp('^tire*', 'i').test(part.taxonomy.partTypeName)) {
      item.type = 'tire';
      item.size = part.tireSize;
      const [brand, ...model] = item.title.split(' ');
      // item.category = { name: brand };  we dont want to show category as brand in any case ALP-16612
      item.model = model.join(' ');

      if (part.attributes && part.attributes.length) {
        item.description = part.attributes.map(({ label, value }) => `${label}: ${value}`).join(', ');

        const season = find(part.attributes, { label: 'Category' });

        if (season) {
          if (new RegExp('all season', 'i').test(season.value)) item.seasonality = 'all';
          else if (new RegExp('winter', 'i').test(season.value)) item.seasonality = 'winter';
          else if (new RegExp('summer', 'i').test(season.value)) item.seasonality = 'summer';
        }
      }
    }

    let setting: any = {};

    if (item.itemSource === 'PartsTech' && this.settings && this.settings.partsTech) {
      setting = (this.settings.partsTech && this.settings.partsTech[item.type]) || {};
    } else if (item.itemSource === 'Nexpart' && this.settings && this.settings.nexpart) {
      setting = this.settings.nexpart[item.type] || {};
    }

    if (setting) {
      item.qboId = (setting && setting.qboId) || '';
      item.isTaxable = setting ? setting.isTaxable : true;
      item.displayHoursOnOrder = setting ? setting.displayHoursOnOrder : true;
      item.displayDescOnOrder = setting ? setting.displayDescOnOrder : true;

      if (setting.pricing && setting.partsTechCostCalMethod === 'pricing-matrix') {
        item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, setting.pricing);
        item.pricing = {
          pricingId: setting.pricing._id,
          name: setting.pricing.name,
        };
        item.subTotal = item.price * item.count;
      }
    }

    if (this.customFleetSettings.isPricingMatrixOverride && this.customFleetSettings.customPartPricingMatrix) {
      item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, this.customFleetSettings.customPartPricingMatrix);
      item.pricing = {
        pricingId: this.customFleetSettings.customPartPricingMatrix._id,
        name: this.customFleetSettings.customPartPricingMatrix.name,
      };
      item.subTotal = item.price * item.count;
    }

    if (item.itemSource === 'PartsTech') {
      const partsTechTags = find(this.tags, { name: 'PartsTech' });

      if (partsTechTags) {
        item.tags.push(partsTechTags);
      }
    } else if (item.itemSource === 'Nexpart') {
      const nexpartTags = find(this.tags, { name: 'Nexpart' });

      if (nexpartTags) {
        item.tags.push(nexpartTags);
      }
    }

    if (item.itemSource === 'PartsTech') {
      if (part.availability && order.delivery && order.delivery.name) {
        const tag = find(this.tags, { name: 'Available' });
        item.tags.push(tag);
      } else {
        const tag = find(this.tags, { name: 'Not Available' });
        item.tags.push(tag);
      }
    } else if (item.itemSource === 'Nexpart') {
      if (part.availability) {
        const tag = find(this.tags, { name: 'Available' });
        item.tags.push(tag);
      } else {
        const tag = find(this.tags, { name: 'Not Available' });
        item.tags.push(tag);
      }
    }

    return item;
  };

  isServiceAssigned = (type: string) => {
    for (let i = 0; i < this.estimate.services.length; i++) {
      const { items } = this.estimate.services[i];

      for (let j = 0; j < items.length; j++) {
        const { itemSource, orderItemId } = items[j];

        if (itemSource === type && orderItemId) {
          return true;
        }
      }
    }

    return false;
  };

  handlePlaceOrderSync = (type: string) => {
    if (this.isFinalizedRo) return;

    if (this.isServiceAssigned(type)) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: `Place order and overwrite service line details`,
          message: `Overwriting will replace any manually entered name, description and price on Service lines and will use the latest values from Parts Order`,
          button: {
            success: {
              title: 'Overwrite',
              backgroundColor: '#ef322f',
              color: '#ffffff',
            },
            cancel: { title: 'Do not overwrite' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (data && data.btn !== 'close') {
          this.placeOrder(false, isSuccess);
        }

        onClose.unsubscribe();
      });
    } else {
      this.placeOrder(false, true);
    }
  };

  syncManualOrder = (data: any) => {
    //here we fecting new record when data updated in modal and when modal closes its update the data
    if (data) {
      const _data = this.setManualQoutes(data);
      let orders = [];
      if (_data && _data.length >= 0) {
        _data.forEach((qoute: any) => {
          this._manualQoutes.push(qoute);
          orders = [...orders, qoute];
        });
        this._orders.manualOrder = this.setManualOrderDetails(_data);
      }
    }

    //here we fecting new record when data updated in modal and when modal closes its update the data
    if (data.nexpartQoute) {
      const _data = this.setNexpartQoutes(data);
      let orders = [];
      if (_data && _data.length >= 0) {
        _data.forEach((qoute: any) => {
          this._nexpartQoutes.push(qoute);
          orders = [...orders, qoute];
        });
        this._orders.nexpart = this.setNexpartDetails(_data, false);
      }
    }

    //here we fecting new record when data updated in modal and when modal closes its update the data
    if (data.partsTechQoute) {
      let orders = [];
      this._partsTechQoutes = [];
      if (this.isAlreadySettinged) {
        this.isAlreadySettinged = false;
        return;
      }
      const _data = this.setPartsTechQoutes(data);
      if (_data && _data.length) {
        _data.forEach((qoute: any) => {
          this._partsTechQoutes.push(qoute);
          orders = [...orders, qoute];
        });
        this.hasOrders = !!orders.length;
        this.orders = this.setOrderDetails(_data, false);
        this.defaultOrders = this.helperService.deepCopy(this.orders);
      }
    }
    let checkOrderPlaced = [...this._orders.manualOrder, ...this.orders, ...this._orders.nexpart];
    this.appUpdateManualItemOrder.emit({ checkOrderPlaced: checkOrderPlaced.find((order) => !order.isOrderPlaced), manualOrder: this._orders.manualOrder });
  };

  handleDeliverManualOrder = (qouteId: string, orderStatus: string, qoute) => {
    if (this.isFinalizedRo) return;

    if (qoute.qouteId) {
      qoute[qoute.qouteId] = true;
    }
    this.isPlacingOrder.manualOrder = true;
    this.httpService
      .updateManualOrderOrderStatus({ qouteId, orderId: this.estimate._id, orderStatus })
      .then(
        (data) => {
          this.syncManualOrder(data);
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isPlacingOrder.manualOrder = false;
        qoute[qoute.qouteId] = false;
      });
  };
}
